import { render, staticRenderFns } from "./EmailField.vue?vue&type=template&id=1cfb47fa&scoped=true"
import script from "./EmailField.vue?vue&type=script&lang=js"
export * from "./EmailField.vue?vue&type=script&lang=js"
import style0 from "./EmailField.vue?vue&type=style&index=0&id=1cfb47fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb47fa",
  null
  
)

export default component.exports